import { isURP } from "@tvg/utils/generalUtils";
import { AccountRolesEnum } from "@tvg/ts-types/Account";
import { get } from "lodash";
import parseCAPIMessage from "@tvg/utils/capiUtils";
import { Store } from "@reduxjs/toolkit";
import { TalentPicksDefaultMessages } from "../types";
import { talentPicksDefaultMessages } from "./defaultValues";

export const getTalentPicksPageMsgs = (
  store: Store
): TalentPicksDefaultMessages =>
  parseCAPIMessage(
    store,
    "capi.messages.TalentPicksPage",
    talentPicksDefaultMessages
  );

export const getBlacklistedWagerTypes = (store: unknown) =>
  isURP
    ? parseCAPIMessage(store, "capi.messages.URP_FDRBlacklistedBets", undefined)
    : parseCAPIMessage(store, "capi.messages.FDRBlacklistedBets", undefined);

export const getTalentPicksSectionTitle = (store: Store) =>
  parseCAPIMessage(store, "capi.messages.TalentPicks_pgp", "FDTV Picks");

export const getTalentPicksListSize = (store: Store) =>
  parseCAPIMessage(store, "capi.messages.numTPCardstoShowInHP", 5);

export const getTalentPicksErrorCodes = (store: Store) =>
  parseCAPIMessage(store, "capi.messages.talentPicksToolErrorCodes", {});

export const getTalentPicksToggleONPgP = (store: Store) =>
  parseCAPIMessage(store, "capi.featureToggles.talentPicksOnProgPage", false);

export const getEnableURPTalentPicksTool = (store: Store) =>
  parseCAPIMessage(
    store,
    "capi.featureToggles.enableURPTalentPicksTool",
    false
  );

export const userRoles = (store: Store): Array<AccountRolesEnum> =>
  get(store, "userData.user.accountRoles", []);

export const getTalentPicksSelectedTalent = (store: Store) =>
  get(store, "talentPicks.talent.selectedTalent", null);
